import { defineStore } from "pinia";
import API from '@/api';
import { getPrivate } from '@/api/PcModule/home';
export const useUserStore = defineStore({
  id: 'user', // 必填，唯一
  state: () => {
    return {
      userInfo: {},
      temporaryUserInfo:{},
      temporaryUserId:'',
      menuList: [],
      messageNum: 0,
      private: [],
      brandData: [],
      bannerList: [],
      contentData: {},
      reloadNow: '',
      onceLogin: '',
      lastPath: {},
      isLoginPath:false,
      fetchSearchData: [],
      isMusic:false,   // 是否开启提示音
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage,//localStorage存储多个key
        paths: ['userInfo','temporaryUserInfo','menuList','isLoginPath','temporaryUserId','messageNum', 'private', 'brandData', 'contentData', 'fetchSearchData', 'bannerList', 'reloadNow', 'onceLogin', 'lastPath','isMusic'],
      },
    ],
  },
  actions: {
    // 获取菜单
    async getMenu() {
      let data = await API.getmenu();
      if (data.code == 200) {
        this.menuList = data.data.catalog2VOS || []
      }
    },
    // 获取消息
    async getMessage() {
      if (this.userInfo.id) {
        const res:any = await API.getReadStatusCount({
          notifyChannel: 1,
          receiverId: this.userInfo.id
        });
        if (res.code == 200) {
          const data = res.data || []
          data.map(item=>{
            if (item.messageType==='0') {
              this.messageNum = Number(item.unreadCount) || 0
            }
          })
        }
      }
    },
    async getPrivateApi(id) {
      let data = await getPrivate(id);
      if (data) {
        if (this.private.findIndex((val) => val.id === data.id) !== -1) {
          let index = this.private.findIndex((val) => val.id === data.id);
          this.private.splice(index, 1, data);
        } else {
          this.private.push(data)
        }
      }
    }
    //获取指纹
  }
})